import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { compose, lifecycle,  withHandlers, withState } from 'recompose'
//import { FormattedMessage } from 'react-intl'
import Swiper from 'react-id-swiper'
import { Helmet } from 'react-helmet'

import LotsList from './LotList/index'
import Hero from './../components/Hero'
//import Link from './../components/Link'
import NewsList from '../components/News/PreviewList'
import FundsList from '../components/Funds/PreviewList'

import { getTotalSum } from '../selectors/home.js'
import { getHomeData } from './../store/reducers/home'
import { get as getNews } from './../store/reducers/news'
import { getList as getPartners } from './../store/reducers/partners'
//import { getFunds as getFundsSelector } from './../selectors/funds.js'
import { clearList, getFunds, getTotal } from './../store/reducers/funds/list.js'
const Home = ({ funds = [], news = [], fetching, total = 0, fundsTotal, partners, meta }) => {
  //статический список фондов
  funds = [
  {_id: "59c2950d3a8eb0652ed7a807", name: "Линия жизни", sum: null, currency: null},
  {_id: "607d493ad82a2d753920965c", name: "Обнаженные сердца", sum: null, currency: null},
  {_id: "59e065c69c1d521a86c6cb25", name: "Дом с маяком", sum: null, currency: null},
]

  this.swiperRef2 = null

  const params_logos = {
    grabCursor: false,//true
    centeredSlides: true,
    loop: true,
    rebuildOnUpdate: true,
    spaceBetween: 30,
  }

  const goNext = (ref) => {
    console.log(ref);
    if (ref && ref.swiper) {
      ref.swiper.slideNext();
    }
  };
  const goPrev = (ref) => {
    if (ref && ref.swiper) {
      ref.swiper.slidePrev();
    }
  };
  return fetching ? null : (
  <div>
    <Hero sum={total} />
    <Helmet>
        <title>{meta.name}</title>
        <meta name='description' content={meta.description} />
        <meta property='og:title' content={meta.name} />
        <meta property='og:image' content={meta.image} />
        <meta property='og:url' content={window.location.href} />
        <meta property='og:description' content={meta.description} />
      </Helmet>
    <div className='Home__section Home__persons'>
      {/* TODO: lots <LotsList className='Home__persons-list Home__persons-list_special' limit={3} type={'closingSoon'} params={{ isFeatured: 1 }} isSpecial /> */}
      <LotsList className='Home__persons-list' typelot={'allForIndex'} limit={50} type={'newPublished'} listName={'Главная страница'} expandable />

      {/*<div className='Home__more' style={{ zIndex: 99, position: 'relative' }}>
        <Link to='/lots' className='Button Button_black'>
          <FormattedMessage id='home.see_all_auctions' />
        </Link>
      </div>*/}
    </div>

    { (news.length > 0) && (
      <div className='Home__section Home__news'>
        <div className='Container'>
          <NewsList items={news} />
        </div>
      </div>
    )}

    { (funds.length > 0) && (
      <div className='Home__section Home__founds'>
        <div className='Container'>
          <FundsList items={funds} total={fundsTotal} />
        </div>
      </div>
    )}

    {/* {(partners.length > 0) && (
      <div className='Home__section Home__partners'>
        <div className='AboutUs__team-wrap _swiperList Container' style={{textAlign: 'center'}}>
          <button onClick={()=>goPrev(this.swiperRef2)} className="partners-slider-prev"></button>
          <Swiper {...params_logos}  ref={instance=>this.swiperRef2=instance} slidesPerView={(window.innerWidth < 667) ? 1 : 3}>
            {partners.map(el => (
              <div key={el.url} className='Partners-item'>
                <a href={el.url} target='_blank' className='Home__partners-item'>
                  <img key={el._id} className='Home__partners-item Partners-item-img' alt={el.name} src={el.image} />
                </a>
              </div>
            ))}
          </Swiper>
          <button onClick={()=>goNext(this.swiperRef2)} className="partners-slider-next"></button>
        </div>
      </div>
    )} */}
  </div>
)}

const mapStateToProps = state => ({
  //закомментировано так как выводим статический список фондов
  //funds: getFundsSelector(state),
  news: state.news.items,
  total: getTotalSum(state),
  fetching: state.home.fetching,
  fundsTotal: state.funds.list.total,
  partners: Object.values(state.partners.items)
})

const mapDispatchToProps = dispatch => bindActionCreators({ clearList, getFunds, getNews, getHomeData, getPartners, getTotal }, dispatch)

const mergeProps = (state, dispatch, props) => ({
  ...state,
  ...props,
  getData: () => {
    dispatch.clearList()
    return Promise.all([
      dispatch.getHomeData(),
      dispatch.getNews({ limit: 3 }),
      //закомментировано так как выводим статический список фондов
      //dispatch.getFunds(0, { limit: 6, withoutProcessing: true }),
      dispatch.getTotal(),
      dispatch.getPartners()
    ])
  }
})

export default compose(
  withState('focusSlide', 'setFocusSlide', undefined),
  withState('ordinaryMode', 'setOrdinaryMode', false),
  connect(mapStateToProps, mapDispatchToProps, mergeProps),
  withHandlers({
    setSize: (props) => e => {
      if (window.innerWidth < 667)
        props.setOrdinaryMode(true)
      else
        props.setOrdinaryMode(false)
    },
  }),
  lifecycle({
    async componentWillMount () {
      await this.props.getData();
      this.props.setSize();
      window.addEventListener('resize', this.props.setSize);
    },
    componentWillUnmount() {
      window.removeEventListener('resize', this.props.setSize);
    }
  })
)(Home)



// WEBPACK FOOTER //
// ./src/containers/Home.jsx